import { getEnv } from 'sidecar-utilities'

const CLIENT_IDS = {
  dev: '609b33b13287e30bfa954518',
  qa: '609b336d3287e30bfa954503',
  prod: '609b194d65f0430f40a87adb',
}

/**
 * LD has 3 environments (dev, qa, prod) and each environment has its own
 * client id. This function will return the correct client id based on
 * APP_ENV. If the env is not recognized it will default to the dev client id.
 *
 * @returns {string} launch darkly clientside id
 */
export const resolveClientSideID = () => CLIENT_IDS[getEnv()] || CLIENT_IDS.dev
